import {
  LOGIN_USER,
  SET_AUTH_LOADING,
  SET_USER_DATA,
  LOGOUT,
  SET_HYDRATION,
  SET_ASPIRATION_DETAILS,
} from "../actions/action.types";

const getRefreshToken = () => {
  localStorage.getItem("refreshToken");
};

const initialState = {
  logged_in: false,
  authenticated: false,
  clientDeviceId: null,
  // logged_in: true,
  // authenticated: true,
  loading: true,
  user: null,
  companyDetails: {},
  linkedAccount: {},
  token: "",
  aspirationDetails: null,
  refreshToken: getRefreshToken,
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case LOGIN_USER:
      let {
        user,
        companyDetails,
        token,
        refreshToken,
        clientDeviceId,
        linkedAccount,
      } = payload;
      localStorage.setItem("accessToken", token);
      localStorage.setItem("refreshToken", refreshToken);
      return {
        ...state,
        logged_in: true,
        loading: false,
        authenticated: true,
        user: user,
        clientDeviceId: clientDeviceId,
        companyDetails: companyDetails ?? {},
        linkedAccount: linkedAccount ?? {},
        token: token,
        stripeAccountId: user?.stripeAccountId,
        userType: user?.userType,
      };
    case SET_USER_DATA:
      return {
        ...state,
        logged_in: true,
        loading: false,
        authenticated: true,
        user: { ...state.user, ...payload },
        companyDetails: {
          ...state.companyDetails,
          ...(payload?.companyDetails ? payload?.companyDetails : {}),
        },
        linkedAccount: {
          ...state.linkedAccount,
          ...(payload?.linkedAccount ?? {}),
        },
        token: payload?.token,
        clientDeviceId: payload?.clientDeviceId || state?.clientDeviceId,
      };
    case SET_ASPIRATION_DETAILS:
      return {
        ...state,
        aspirationDetails: state.aspirationDetails
          ? { ...state.aspirationDetails, ...payload }
          : payload,
      };
    case SET_HYDRATION:
      return {
        ...state,
        loading: payload,
      };
    case SET_AUTH_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case LOGOUT:
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      return { ...initialState, loading: false };
    default:
      return state;
  }
};

export default authReducer;
